(() => {
  const script = document.currentScript;
  if (!script || !document.body.classList.contains('mewo-store')) return;
  const styleUrl = script.dataset.styleUrl;
  const photoUrl = script.dataset.photoUrl;
  const hostSelector = 'shopify-forms-embed#app-embed-container-985720';
  const destinations = {
    Birthday: '/collections/custom-birthday-temporary-tattoos',
    Wedding: '/collections/custom-wedding-temporary-tattoos',
    Bachelorette: '/collections/custom-bachelorette-temporary-tattoos',
    Other: '/collections/all'
  };
  const add = (parent, tag, className, text) => {
    const element = document.createElement(tag);
    element.className = className;
    if (text) element.textContent = text;
    parent.append(element);
    return element;
  };
  const enhance = root => {
    const panel = root.querySelector('[data-sizing="form-wrapper"][role="dialog"]');
    if (!panel) return;
    panel.dataset.mewoWelcome = '';
    const form = panel.querySelector('form');
    const nativeHeading = panel.querySelector('h2:not(.mw-heading)');
    if (!nativeHeading) return;
    const state = form ? 'signup' : 'success';
    if (panel.dataset.mewoWelcomeState && panel.dataset.mewoWelcomeState !== state) {
      panel.querySelectorAll('.mw-brand,.mw-eyebrow,.mw-heading,.mw-dismiss,.mw-next').forEach(el => el.remove());
    }
    panel.dataset.mewoWelcomeState = state;
    const content = Array.from(panel.children).find(el => el.contains(nativeHeading));
    if (!content) return;
    content.classList.add('mw-content');
    panel.classList.toggle('mw-success-state', !form);
    const close = panel.querySelector('[aria-label="Close modal"]');
    if (close) close.classList.add('mw-native-close');
    let photo = panel.querySelector('.mw-photo');
    if (!photo && photoUrl) {
      photo = Array.from(panel.children).find(el => el.style.backgroundImage);
      if (photo) {
        photo.classList.add('mw-photo');
        photo.style.backgroundImage = `url("${photoUrl}")`;
        photo.setAttribute('role', 'img');
        photo.setAttribute('aria-label', 'Two friends enjoying their personalized face and pet tattoos');
        add(photo, 'div', 'mw-photo-caption', 'Small tattoos.\nBig reactions.');
      }
    }
    if (!content.querySelector('.mw-brand')) {
      const brand = document.createElement('div');
      brand.className = 'mw-brand';
      brand.textContent = 'mewo';
      add(brand, 'span', '', '.');
      content.prepend(brand);
    }
    const header = nativeHeading.parentElement;
    header.classList.add('mw-header');
    if (!header.querySelector('.mw-eyebrow')) {
      const eyebrow = document.createElement('p');
      eyebrow.className = 'mw-eyebrow';
      eyebrow.textContent = form ? 'A LITTLE WELCOME GIFT' : 'YOU’RE ON THE LIST';
      nativeHeading.before(eyebrow);
    }
    nativeHeading.classList.add('mw-native-heading');
    if (!header.querySelector('.mw-heading')) {
      const heading = document.createElement('h2');
      heading.className = 'mw-heading';
      heading.textContent = form ? '10% OFF' : 'A little gift.';
      add(heading, 'span', '', form ? 'your first order' : 'On its way.');
      nativeHeading.after(heading);
    }
    if (form) {
      form.classList.add('mw-form');
      const email = form.querySelector('#email');
      if (email) {
        email.parentElement.classList.add('mw-email-field');
        email.setAttribute('placeholder', 'you@example.com');
        email.setAttribute('autocomplete', 'email');
      }
      const submit = form.querySelector('[type="submit"]');
      submit?.classList.add('mw-submit');
      if (!content.querySelector('.mw-dismiss')) {
        const dismiss = add(content, 'button', 'mw-dismiss', 'Maybe later');
        dismiss.type = 'button';
        dismiss.addEventListener('click', () => close?.click());
      }
    } else if (!content.querySelector('.mw-next')) {
      const next = add(content, 'div', 'mw-next');
      const label = add(next, 'label', 'mw-occasion', 'What are you celebrating? ');
      add(label, 'span', '', '(optional)');
      const select = add(label, 'select', 'mw-occasion-select');
      const placeholder = add(select, 'option', '', 'Choose your occasion');
      placeholder.value = '';
      Object.keys(destinations).forEach(occasion => {
        add(select, 'option', '', occasion).value = occasion;
      });
      const link = add(next, 'a', 'mw-submit mw-continue', 'Find my party favorite →');
      link.href = '/collections/all';
      select.addEventListener('change', () => { link.href = destinations[select.value] || '/collections/all'; });
    }
  };
  const connected = new WeakSet();
  const connect = () => {
    const host = document.querySelector(hostSelector);
    const root = host?.shadowRoot;
    if (!root || connected.has(root)) return Boolean(root);
    connected.add(root);
    const stylesheet = document.createElement('link');
    stylesheet.rel = 'stylesheet';
    stylesheet.href = styleUrl;
    root.append(stylesheet);
    let scheduled = false;
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; enhance(root); });
    });
    observer.observe(root, { childList: true, subtree: true });
    enhance(root);
    return true;
  };
  // Forms creates its shadow root only when the visitor is eligible for the offer.
  const documentObserver = new MutationObserver(connect);
  documentObserver.observe(document.body, { childList: true, subtree: true });
  let attempts = 0;
  const timer = setInterval(() => {
    if (connect() || ++attempts >= 120) clearInterval(timer);
  }, 500);
  connect();
})();
